import * as types from "./types";
import INITIAL_STATE from "./init";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_ORGANIZATION: {
      return { ...state, ...action.payload };
    }
    case types.SET_BACKGROUND_IMAGE: {
      return { ...state, background: action.payload };
    }
    case types.SET_LOGO_IMAGE: {
      return { ...state, logo: action.payload };
    }
    case types.SET_ORGANIZATION_SLUG: {
      return { ...state, slug: action.payload };
    }
    case types.SET_RESPONSIBLE_USERS: {
      return { ...state, responsibleUsers: action.payload };
    }
    case types.SET_FEEDBACK_ASSIGNEE: {
      return { ...state, assignee_id: action.payload.value };
    }
    case types.ADD_DIVISIONS: {
      return { ...state, divisions: action.payload };
    }
    default:
      return state;
  }
};
